export enum LanguageCode {
  af = 'af',
  sq = 'sq',
  ar = 'ar',
  hy = 'hy',
  az = 'az',
  eu = 'eu',
  be = 'be',
  bn = 'bn',
  bs = 'bs',
  bg = 'bg',
  ca = 'ca',
  zh = 'zh',
  zh_CN = 'zh-CN',
  zh_HK = 'zh-HK',
  zh_TW = 'zh-TW',
  hr = 'hr',
  cs = 'cs',
  da = 'da',
  nl = 'nl',
  en = 'en',
  en_AU = 'en-AU',
  en_GB = 'en-GB',
  et = 'et',
  fa = 'fa',
  fi = 'fi',
  fil = 'fil',
  fr = 'fr',
  fr_CA = 'fr-CA',
  gl = 'gl',
  ka = 'ka',
  de = 'de',
  el = 'el',
  gu = 'gu',
  iw = 'iw',
  hi = 'hi',
  hu = 'hu',
  is = 'is',
  id = 'id',
  it = 'it',
  ja = 'ja',
  kn = 'kn',
  kk = 'kk',
  km = 'km',
  ko = 'ko',
  ky = 'ky',
  lo = 'lo',
  lv = 'lv',
  lt = 'lt',
  mk = 'mk',
  ms = 'ms',
  my = 'my',
  ml = 'ml',
  mr = 'mr',
  mn = 'mn',
  ne = 'ne',
  no = 'no',
  pl = 'pl',
  pt = 'pt',
  pt_BR = 'pt-BR',
  pt_PT = 'pt-PT',
  pa = 'pa',
  ro = 'ro',
  ru = 'ru',
  sr = 'sr',
  siv = 'siv',
  sk = 'sk',
  sl = 'sl',
  es = 'es',
  es_419 = 'es-419',
  sw = 'sw',
  sv = 'sv',
  ta = 'ta',
  te = 'te',
  th = 'th',
  tr = 'tr',
  uk = 'uk',
  ur = 'ur',
  uz = 'uz',
  vi = 'vi',
  zu = 'zu',
}
